import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/professional-unavailability';

const get = async (
	params: ProfessionalUnavailabilitys.UnavailabilityParams,
): Promise<ProfessionalUnavailabilitys.GetUnavailabilityRespose> => {
	const queryParams = createQueryParams({ ...params });
	const { data } = await api.get(`${DOMAIN}/me?${queryParams}`);
	return data;
};

const create = async (
	body: ProfessionalUnavailabilitys.Create,
): Promise<ProfessionalUnavailabilitys.ProfessionalUnavailability> => {
	return await api.post(`${DOMAIN}`, body);
};

const patch = async (
	data: ProfessionalUnavailabilitys.ProfessionalUnavailability,
): Promise<ProfessionalUnavailabilitys.ProfessionalUnavailability> => {
	const { id, ...body } = data;
	return await api.patch(`${DOMAIN}/${id}`, body);
};

const destroy = async (id: string) => {
	await api.delete(`${DOMAIN}/${id}`);
};

const ProfessionalUnavailabilityService = {
	get,
	create,
	patch,
	destroy,
};

export { ProfessionalUnavailabilityService };
